import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconBall = ({ classProps }: PropsWithClassProps) => {
  const svgStyle = twMerge('w-4 h-4', classProps?.root);
  return (
    <svg className={svgStyle} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.10004 13.94C5.08004 13.94 5.05337 13.9533 5.03337 13.9533C3.74004 13.3133 2.68671 12.2533 2.04004 10.96C2.04004 10.94 2.05337 10.9133 2.05337 10.8933C2.86671 11.1333 3.70671 11.3133 4.54004 11.4533C4.68671 12.2933 4.86004 13.1266 5.10004 13.94Z"
        fill="currentColor"
      />
      <path
        d="M13.9604 10.9666C13.3004 12.2933 12.2004 13.3666 10.8604 14.0133C11.1137 13.1666 11.327 12.3133 11.467 11.4533C12.307 11.3133 13.1337 11.1333 13.947 10.8933C13.9404 10.92 13.9604 10.9466 13.9604 10.9666Z"
        fill="currentColor"
      />
      <path
        d="M14.0137 5.14003C13.1737 4.88669 12.327 4.68003 11.467 4.53336C11.327 3.67336 11.1204 2.82003 10.8604 1.98669C12.2404 2.64669 13.3537 3.76003 14.0137 5.14003Z"
        fill="currentColor"
      />
      <path
        d="M5.10064 2.06004C4.86064 2.87337 4.6873 3.70004 4.5473 4.54004C3.6873 4.67337 2.83397 4.88671 1.9873 5.14004C2.63397 3.80004 3.7073 2.70004 5.03397 2.04004C5.05397 2.04004 5.08064 2.06004 5.10064 2.06004Z"
        fill="currentColor"
      />
      <path
        d="M10.3262 4.39337C8.77952 4.22004 7.21952 4.22004 5.67285 4.39337C5.83952 3.48004 6.05285 2.56671 6.35285 1.68671C6.36618 1.63337 6.35952 1.59337 6.36618 1.54004C6.89285 1.41337 7.43285 1.33337 7.99952 1.33337C8.55952 1.33337 9.10618 1.41337 9.62618 1.54004C9.63285 1.59337 9.63285 1.63337 9.64619 1.68671C9.94619 2.57337 10.1595 3.48004 10.3262 4.39337Z"
        fill="currentColor"
      />
      <path
        d="M4.39301 10.3267C3.47301 10.16 2.56634 9.94667 1.68634 9.64667C1.63301 9.63334 1.59301 9.64001 1.53967 9.63334C1.41301 9.10667 1.33301 8.56667 1.33301 8.00001C1.33301 7.44001 1.41301 6.89334 1.53967 6.37334C1.59301 6.36667 1.63301 6.36667 1.68634 6.35334C2.57301 6.06001 3.47301 5.84001 4.39301 5.67334C4.22634 7.22001 4.22634 8.78001 4.39301 10.3267Z"
        fill="currentColor"
      />
      <path
        d="M14.6664 8.00001C14.6664 8.56667 14.5864 9.10667 14.4598 9.63334C14.4064 9.64001 14.3664 9.63334 14.3131 9.64667C13.4264 9.94001 12.5198 10.16 11.6064 10.3267C11.7798 8.78001 11.7798 7.22001 11.6064 5.67334C12.5198 5.84001 13.4331 6.05334 14.3131 6.35334C14.3664 6.36667 14.4064 6.37334 14.4598 6.37334C14.5864 6.90001 14.6664 7.44001 14.6664 8.00001Z"
        fill="currentColor"
      />
      <path
        d="M10.3262 11.6067C10.1595 12.5267 9.94619 13.4334 9.64619 14.3134C9.63285 14.3667 9.63285 14.4067 9.62618 14.46C9.10618 14.5867 8.55952 14.6667 7.99952 14.6667C7.43285 14.6667 6.89285 14.5867 6.36618 14.46C6.35952 14.4067 6.36618 14.3667 6.35285 14.3134C6.05952 13.4267 5.83952 12.5267 5.67285 11.6067C6.44618 11.6934 7.21952 11.7534 7.99952 11.7534C8.77952 11.7534 9.55952 11.6934 10.3262 11.6067Z"
        fill="currentColor"
      />
      <path
        d="M10.5086 10.5089C8.84116 10.7193 7.15818 10.7193 5.49079 10.5089C5.28041 8.84153 5.28041 7.15855 5.49079 5.49115C7.15818 5.28078 8.84116 5.28078 10.5086 5.49115C10.7189 7.15855 10.7189 8.84153 10.5086 10.5089Z"
        fill="currentColor"
      />
    </svg>
  );
};
